/**
 * 全局存储-VUEX，文档：https://vuex.vuejs.org/zh/guide/modules.html
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/modules/user";

import getters from "@/store/getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    // 客户模块
    user,
  
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js